<template>
  <div
    :class="
      embedded
        ? 'ocr-table-section-body ocr-table-section-body--embedded ocr-table-section-body--skeleton'
        : 'ocr-table-section ocr-table-section--skeleton'
    "
  >
    <div v-if="!embedded" class="table-title-div">
      <span v-if="title">{{ title }}</span>
      <OcrSkLine v-else width="120px" height="14px" />
    </div>
    <div :class="embedded ? '' : 'ocr-table-section-body'">
      <div class="ocr-shimmer-thead">
        <div v-for="(col, idx) in columns" :key="'h-' + idx" class="ocr-shimmer-th">
          <OcrSkLine :width="colWidth(col)" height="12px" />
        </div>
      </div>
      <div class="ocr-shimmer-tbody">
        <div v-for="row in rowCount" :key="row" class="ocr-shimmer-tr">
          <div v-for="(col, idx) in columns" :key="'c-' + row + '-' + idx" class="ocr-shimmer-td">
            <OcrSkLine :width="cellWidth(idx)" height="12px" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OcrSkLine from "@/components/layout/OCR/OcrSkLine.vue";

export default {
  name: "OcrTableSectionSkeleton",
  components: { OcrSkLine },
  props: {
    title: { type: String, default: "" },
    columns: { type: Array, default: () => ["File name"] },
    rowCount: { type: Number, default: 5 },
    embedded: { type: Boolean, default: false },
  },
  methods: {
    colWidth(col) {
      const len = String(col).length;
      return `${Math.min(120, Math.max(56, len * 7))}px`;
    },
    cellWidth(idx) {
      const widths = ["68%", "52%", "44%"];
      return widths[idx % widths.length];
    },
  },
};
</script>
